import { Inject, Injectable } from '@angular/core'
import { Account, GetProfileGQL, GetProfileQuery } from '../../../generated/DTM/graphql'
import { BehaviorSubject, Observable, of } from 'rxjs'
import { SBS_ENVIRONMENT } from '../../sbs-common.module'
import { SbsEnvironment } from '../models/sbs-environment'
import { Scores } from '../../../generated/common/graphql'
import { GetParticipantProfileGQL, GetParticipantProfileQuery, HighScoreEntry } from '../../../generated/chaser/graphql'
import { map, tap } from 'rxjs/operators'

export type Profile = GetProfileQuery['getAccountById']
export type ChaserProfile = GetParticipantProfileQuery['getAccountById']

export interface UserScoreDetails {
  score: Scores
  totalScore: number
  loginName: string
}

export const emptyUserScore: HighScoreEntry = {
  _id: '',
  totalScore: 0,
  loginName: '',
  currentStreak: 0,
  longestStreak: 0,
}

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(
    @Inject(SBS_ENVIRONMENT) private env: SbsEnvironment,
    private getProfileGQL: GetProfileGQL,
    private getParticipantProfileGQL: GetParticipantProfileGQL,
  ) {}

  public getProfile(id: string): Observable<Profile> {
    return this.getProfileGQL
      .fetch(
        {
          id,
        },
        {
          fetchPolicy: 'network-only',
        },
      )
      .pipe(map((result) => result.data.getAccountById))
  }

  public getParticipantProfile(id: string): Observable<ChaserProfile> {
    return this.getParticipantProfileGQL
      .fetch(
        {
          id,
        },
        {
          fetchPolicy: 'network-only',
        },
      )
      .pipe(map((result) => result.data.getAccountById))
  }

  public getProfileFromLocalStorage(): ChaserProfile | Profile | null {
    const profileJson = window.localStorage.getItem(this.env.profileKey)
    if (profileJson) {
      return JSON.parse(profileJson)
    }
    return null
  }

  // getChaserProfileFromLocalStorage(): ChaserProfile {
  //   const profile = this.getProfileFromLocalStorage()
  //   if (profile && (profile as ChaserProfile).score !== undefined) {
  //     return profile as ChaserProfile
  //   }
  //   throw new Error('Chaser profile not found in local storage')
  // }

  public getProfileFromLocalStorageObservable(): Observable<ChaserProfile | Profile | null> {
    return of(this.getProfileFromLocalStorage())
  }

  public setProfileInLocalStorage(profile: ChaserProfile | Profile) {
    window.localStorage.setItem(this.env.profileKey, JSON.stringify(profile))
  }

  public clearProfile() {
    window.localStorage.removeItem(this.env.profileKey)
  }
}
